<template>
  <div>
    <img style="width: 100%;height: auto;" src="../../static/images/top_bg.png"/>
    <div style="width: 100%;text-align: center;">
      <img class="top-img" src="../../static/images/top_title.png"/>
    </div>
    <div class="text">
      About ChinaFIX
    </div>
    <div class="text-line"></div>
    <div class="desc">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ChinaFIX group is the world’s largest electronic product maintenance technology
      exchange platform website and an entity company of www.chinafix.com,
      Founded in 2007。 Main business is related to the maintenance technology of mobile phones, tablets, laptops and
      PCs.<br/><br/>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The group adheres to the development strategy of taking electronic product
      maintenance technology as the core and
      relies on www.chinafix.com & www.chinafix.tech to provide all-round services for electronic product maintenance
      engineers all over the world, such as technical exchange, technical training, maintenance tool development,
      production and sales, maintenance software development and so on. Integrating the supply chain with end-users, the
      group creates synergy of the group through three business segments: maintenance technology platform, maintenance
      technology college and maintenance tools and software development, continuously improves user experience, and
      provides mature and effective solutions for each maintenance engineer.
    </div>
    <div class="hong">
      <div class="subtitle-hong">HONG KONG XINXUNWEI Technology Co., Ltd</div>
      <div class="acea-row row-middle">
        <img class="address-icon-hong" src="../../static/images/address.png">
        <div class="address-hong">Room 4, 16th Floor, Ho King Commercial Center, 2-16 Fa Yuen Street, Mongkok, Kowloon,
          Hong Kong
        </div>
      </div>
    </div>
    <div class="business-list">

      <div class="business-item" @mousemove="mouseOneenter1" @mouseout="mouseOneout1">
        <div class="business-title">Shenzhen Headquarters</div>
        <div style="position: relative" class="business-img acea-row row-center row-middle" v-if="oneFocus == 0">
          <img src="../../static/images/4pin.png" style="width: 100%;height: 100%">
          <img style="position: absolute;width: 77px;height: 77px" src="../../static/images/play.png">
        </div>
        <video loop controls muted  autoplay id="video1" width="500" height="350" class="business-img" v-else>
          <source src="../../static/images/xunweiyingwen.mp4" type="video/mp4">
        </video>
        <div class="subtitle">Shenzhenshi Xinxunwei Technology Co., Ltd</div>
        <div class="acea-row row-middle">
          <img class="address-icon" src="../../static/images/address.png">
          <div class="address">Junuo Building, Fuhai Science and Technology Industrial Park, Baoan District, Shenzhen,
            China
          </div>
        </div>
      </div>

      <div class="business-item" @mousemove="mouseOneenter" @mouseout="mouseOneout">
        <div class="business-title">Shenzhen Headquarters</div>
        <div style="position: relative" class="business-img acea-row row-center row-middle" v-if="oneFocus == 0">
          <img src="../../static/images/one.png" style="width: 100%;height: 100%">
          <img style="position: absolute;width: 77px;height: 77px" src="../../static/images/play.png">
        </div>
        <video loop controls muted  autoplay id="video1" width="500" height="350" class="business-img" v-else>
          <source src="../../static/images/xunwei.mp4" type="video/mp4">
        </video>
        <div class="subtitle">Shenzhenshi Xinxunwei Technology Co., Ltd</div>
        <div class="acea-row row-middle">
          <img class="address-icon" src="../../static/images/address.png">
          <div class="address">Junuo Building, Fuhai Science and Technology Industrial Park, Baoan District, Shenzhen,
            China
          </div>
        </div>
      </div>
<!--      <div class="business-item" @mousemove="mouseTwoenter" @mouseout="mouseTwoout">-->
<!--        <div class="business-title">Bonded Area OFFICE</div>-->
<!--        <div style="position: relative" class="acea-row row-center row-middle" v-if="twoFocus == 0">-->
<!--          <img src="../../static/images/two.png" class="business-img">-->
<!--          <img style="position: absolute;width: 59px;height: 59px" src="../../static/images/play.png">-->
<!--        </div>-->
<!--        <video loop controls muted  autoplay id="video1" class="business-img" v-else>-->
<!--          <source src="../../static/images/pingshan.mp4" type="video/mp4">-->
<!--        </video>-->
<!--        <div class="subtitle">Shenzhen Yongchengxing Logistics Co., Ltd</div>-->
<!--        <div class="acea-row row-middle">-->
<!--          <img class="address-icon" src="../../static/images/address.png">-->
<!--          <div class="address">301, Building A1,Haixiang Industrial Park,Lanzhu Road,Pingshan Street Export Processing Zone,Pingshan District, Shenzhen-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="business-item" @mousemove="mouseThreeenter" @mouseout="mouseThreeout">
        <div class="business-title">Xinzhizao（XZZ）Factory</div>
        <div style="position: relative" class="acea-row row-center row-middle" v-if="threeFocus == 0">
          <img src="../../static/images/three.png" class="business-img">
          <img style="position: absolute;width: 77px;height: 77px" src="../../static/images/play.png">
        </div>
        <video loop controls muted  autoplay id="video1" class="business-img" style="cursor: pointer" v-else>
          <source src="../../static/images/xinzhizao.mp4" type="video/mp4">
        </video>
        <div class="subtitle">Shenzhenshi Xinzhizao Technology Co., Ltd</div>
        <div class="acea-row row-middle">
          <img class="address-icon" src="../../static/images/address.png">
          <div class="address">Room 302A, Building 3, No. 10 Yongtai East Road, Baoan District, Shenzhen, China</div>
        </div>
      </div>
      <div class="business-item" @mousemove="mouseenter" @mouseout="mouseout">
        <div class="business-title">Shandong OFFICE</div>
        <div style="position: relative" class="acea-row row-center row-middle" v-if="focus == 0">
          <img src="../../static/images/four.png" class="business-img">
          <img style="position: absolute;width: 77px;height: 77px" src="../../static/images/play.png">
        </div>
        <video loop controls muted  autoplay id="video1" class="business-img" v-else>
          <source src="../../static/images/shenzhou.mp4" type="video/mp4">
        </video>
        <div class="subtitle">ChinaInNet（Shandong）Technology Co., Ltd</div>
        <div class="acea-row row-middle">
          <img class="address-icon" src="../../static/images/address.png">
          <div class="address">High-tech Entrepreneurship Center, No. 16, Huanghe Road, Liaocheng City, Shandong Province, China
          </div>
        </div>
      </div>
    </div>
    <div class="contactUs">
      <div class="contactUs-list acea-row row-middle row-between">
        <div class="contactUs-item acea-row row-middle" style="position: relative" @click="openUrl(1)"
             @mousemove="mouseEnterPhoneQr"
             @mouseout="mouseOutPhoneQr">
          <img class="phone-qr" src="../../static/images/phone_qr.png" :style="{'opacity':focusPhoneQr}">
          <img class="contactUs-img" src="../../static/images/phone.png">
          <div>
            <div class="contactUs-title">WhatsApp</div>
            <div class="contactUs-type">+8618823306625</div>
          </div>
        </div>
        <div class="contactUs-item acea-row row-middle" @click="openUrl(2)">
          <img class="contactUs-img" src="../../static/images/facebook.png">
          <div>
            <div class="contactUs-title">Facebook Messenger</div>
            <div class="contactUs-type">https://m.me/xinzhizao</div>
          </div>
        </div>
        <div class="contactUs-item acea-row row-middle" style="position: relative" @mousemove="mouseEnterWechatQr"
             @mouseout="mouseOutWechatQr">
          <img class="wechat-qr" src="../../static/images/wechat_qr.png" :style="{'opacity':focusWechatQr}">
          <img class="contactUs-img" src="../../static/images/wechat.png">
          <div>
            <div class="contactUs-title">WeChat</div>
            <div class="contactUs-type">WeChat：XZM2600</div>
          </div>
        </div>
      </div>
    </div>
    <div class="service-area">
      <div class="service-title" style="text-align: center;">Business field</div>
      <div class="service-content-list acea-row row-middle row-center">
        <div class="item-1">
          <div class="service-item-title" style="display: inline-flex;margin-bottom: 14px">Talent cultivation</div>
          <div class="font-size-14-400">Since 2007, more than 20,000 students have been trained in total, and the
            students are all over China, Southeast Asia, Europe, America and other countries and regions
          </div>
          <img src="../../static/images/service-one.png" style="width: 100%;height: 198px;margin-top: 18px">
        </div>
        <div class="item-2 item-2-bottom">
          <div class="service-item-title" style="display: inline-flex">Maintenance technology development</div>
          <div class="acea-row row-top" style="margin-top: 40px">
            <img style="width: 304px;height: 202px" src="../../static/images/service-two.png">
            <div style="width: 256px;word-break: break-word;margin-left: 23px" class="font-size-14-400">
              Xinxunwei Technology has cooperated with the national electronic industry press to publish more than ten
              maintenance works.
              <br/>
              <br/>
              The authors of the Xunwei series of maintenance books are technical leaders with more than ten years of
              experience in the maintenance industry
            </div>
          </div>
        </div>
        <div class="item-3">
          <div class="service-item-title" style="display: inline-flex;margin-bottom: 14px">Maintenance software and
            system development
          </div>
          <div class="font-size-14-400">Worlds largest maintenance database website. We made a maintenance software for
            laptop and smartphone in many languages version, it includes circuit diagram,
            PCB Layer,schematic, bitmap and maintenance cases for the following products.
          </div>
          <img src="../../static/images/service-three.png" style="width: 100%;height: 312px;margin-top: 17px">
        </div>
        <div class="item-4">
          <div class="service-item-title" style="display: inline-flex;margin-bottom: 14px">Development of tools,
            equipment and fixtures for the maintenance industry
          </div>
          <div class="font-size-14-400">The development team has more than 30 people, and the development language
            involves C/C++, assembly, single-chip microcomputer development, maintenance hardware, and Internet of
            Things development. The company independently develops a variety of maintenance tools and equipment such as
            infrared thermal imagers, chip test racks, optical rework stations, screen laminating machines, and layered
            test racks.
          </div>
          <img src="../../static/images/service-four.png" style="width: 100%;height: 259px;margin-top: 15px">
        </div>
      </div>
    </div>
    <div class="btm acea-row row-middle row-between">
      <div class="btm-list acea-row row-middle row-between">
        <div class="btm-item">
          <div class="btm-margin acea-row row-between row-bottom">
            <img style="width: 120px;height: 120px;" class="btm-icon" src="../../static/images/share.png">
            <div style="text-align: center">
              <div class="btm-title">Share</div>
              <div class="acea-row row-right">
                <div class="title-line"></div>
              </div>
            </div>
          </div>
          <div class="content">
            The significance of the network lies in<br/> sharing so that all people who love<br/> maintenance can obtain various
            resources <br/>and information more conveniently and<br/> comprehensively.
          </div>
        </div>
        <div class="btm-item">
          <div class="btm-margin acea-row row-between row-bottom">
            <img style="width: 120px;height: 120px" class="btm-icon" src="../../static/images/communication.png">
            <div style="text-align: center">
              <div class="btm-title">Communication</div>
              <div class="acea-row row-right">
                <div class="title-line"></div>
              </div>
            </div>
          </div>
          <div class="content">
            Improvement can only be achieved<br/> through communication, especially <br/>professional maintenance practitioners<br/>
            can communicate more, help each other, <br/>exchange what is needed, and make<br/> progress together.
          </div>
        </div>
        <div class="btm-item">
          <div class="btm-margin acea-row row-between row-bottom">
            <img style="width: 120px;height: 120px" class="btm-icon" src="../../static/images/type.png">
            <div>
              <div class="btm-title">Development</div>
              <div class="acea-row row-right">
                <div class="title-line"></div>
              </div>
            </div>
          </div>
          <div class="content">
            We hope to do our best to provide a <br/>one-stop service platform for the majority<br/> of maintenance practitioners
            and <br/>maintenance companies and seek greater<br/> room for development.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      focus: 0,
      oneFocus: 0,
      twoFocus: 0,
      threeFocus: 0,
      focusPhoneQr: 0,
      focusWechatQr: 0
    }
  },
  methods: {
    mouseEnterPhoneQr() {
      this.focusPhoneQr = 1
    },
    mouseOutPhoneQr() {
      this.focusPhoneQr = 0
    },
    mouseEnterWechatQr() {
      this.focusWechatQr = 1
    },
    mouseOutWechatQr() {
      this.focusWechatQr = 0
    },
    mouseenter() {
      this.focus = 1
    },
    mouseout() {
      this.focus = 0
    },
    mouseOneenter() {
      this.oneFocus = 1
    },
    mouseOneout() {
      this.oneFocus = 0
    },
    mouseOneenter1() {
      this.oneFocus = 1

    },
    mouseOneout1() {
      this.oneFocus = 0
    },
    mouseTwoenter() {
      this.twoFocus = 1
    },
    mouseTwoout() {
      this.twoFocus = 0
    },
    mouseThreeenter() {
      this.threeFocus = 1
    },
    mouseThreeout() {
      this.threeFocus = 0
    },
    openUrl(type) {
      window.open(type == 1 ? 'https://wa.me/8618823306625?text=' : 'https://m.me/xinzhizao')
    }
  }
}
</script>

<style>
.top-img {
  width: 67.19%;
  height: auto;
  margin-top: -8%;
}

.text {
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  color: #000000;
}

.text-line {
  width: 264px;
  height: 6px;
  background: #2973FA;
  border-radius: 3px;
  margin: 23px auto 0;
}

.desc {
  width: 68%;
  max-width: 1300px;
  flex-wrap: wrap;
  font-size: 18px;
  line-height: 28px;
  font-family: Arial;
  font-weight: 400;
  color: #000000;
  word-break: break-all;
  margin: 23px auto 0px;
}

.business-list {
  width: 68%;
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /*align-items: center;*/
}

.business-item {
  text-align: center;
}

.business-title {
  font-size: 20px;
  font-family: Arial;
  font-weight: bold;
  color: #000000;
  margin-bottom: 10px;
}

.business-img {
  width: 500px;
  height: 350px;
  cursor: pointer;
}


.hong {
  width: 68%;
  max-width: 1300px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.subtitle-hong {
  font-size: 22px;
  font-family: Arial;
  font-weight: 500;
  color: #000000;
  margin-bottom: 15px;
  margin-top: 15px;
}

.address-icon-hong {
  width: 14px;
  height: 16px;
  margin-right: 7px;
}

.address-hong {
  font-size: 12px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #000000;
  word-break: break-all;
}

.subtitle {
  font-size: 18px;
  font-family: Arial;
  font-weight: 400;
  color: #000000;
  margin-bottom: 15px;
  margin-top: 15px;
}

.address-icon {
  width: 14px;
  height: 16px;
  margin-right: 7px;
}

.address {
  font-size: 14px;
  font-family: Arial;
  font-weight: 400;
  color: #000000;
  text-align: left;
  width: 450px;
  word-break: break-all;
}


.contactUs {
  width: 100%;
  height: auto;
  background: #F7F7F7;
  padding: 32px 0;
  margin-top: 78px;
  margin-bottom: 86px;
}

.contactUs-list {
  width: 68%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 50px;
}

.contactUs-item {
  cursor: pointer;
}

.phone-qr {
  width: 169px;
  height: 169px;
  position: absolute;
  left: -200px;
  opacity: 0;
  transition: opacity 2s;
}

.wechat-qr {
  width: 169px;
  height: 169px;
  position: absolute;
  right: -200px;
  opacity: 0;
  transition: opacity 2s;
}

.contactUs-img {
  width: 68px;
  height: 68px;
  margin-right: 34px;
}

.contactUs-title {
  font-size: 22px;
  font-family: Arial;
  font-weight: bold;
  color: #000000;
}

.contactUs-type {
  font-size: 18px;
  font-family: Arial;
  font-weight: 400;
  color: #666666;
}


.service-title {
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  margin: 0 auto;
}

.service-content-list {
  width: 68%;
  max-width: 1300px;
  margin: 40px auto 43px;
}

.item-1 {
  width: 645px;
  height: 357px;
  padding: 26px 22px 24px;
  background: #F7F7F7;
}

.item-2 {
  width: 645px;
  height: 357px;
  padding: 26px 22px 24px;
}

@media screen and (max-width: 1000px) {
  .item-2 {
    height: auto;
  }

  .item-1 {
    height: auto;
  }

  .item-3 {
    height: auto;
  }

  .item-4 {
    height: auto;
    margin-bottom: 130px;
  }

  .btm-list {
    justify-content: center !important;
  }

  .btm-item {
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 1000px) {
}

.item-4 {
  width: 645px;
  height: 488px;
  background: #F7F7F7;
  padding: 29px 22px 27px
}

.item-3 {
  width: 645px;
  height: 488px;
  padding: 29px 46px 0 0
}

.service-item-title {
  width: auto;
  padding: 0 9px;
  height: 40px;
  line-height: 40px;
  background: #2973FA;
  border-radius: 0px 20px 20px 0px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
}

.font-size-14-400 {
  font-size: 14px;
  font-family: Arial;
  font-weight: 400;
  color: #333333;
}


.btm {
  width: 100%;
  height: auto;
  padding: 95px 0;
  background: #F7F7F7;
}

.btm-list {
  width: 68%;
  max-width: 1300px;
  margin: 0 auto;
}

.btm-item {
  width: 386px;
  height: 358px;
  background: #FFFFFF;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12);
}

.btm-margin {
  margin: 12px 35px 53px 21px
}

.btm-icon:hover {
  transform: scale(1.2);
}

.btm-title {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  margin-bottom: 12px;
}

.title-line {
  width: 49px;
  height: 6px;
  background: #2973FA;
  border-radius: 3px;
  display: flex;
  justify-content: end;
}

.content {
  font-size: 17px;
  font-family: Arial;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
  text-align: left;
  width: 322px;
  word-break: break-all;
  margin: 0 auto;
}


.acea-row {
  display: -webkit-box;
  display: -moz-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-lines: multiple;
  -moz-box-lines: multiple;
  -o-box-lines: multiple;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap
}

.acea-row.row-middle {
  -webkit-box-align: center;
  -moz-box-align: center;
  -o-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center
}

.acea-row.row-top {
  -webkit-box-align: start;
  -moz-box-align: start;
  -o-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start
}

.acea-row.row-bottom {
  -webkit-box-align: end;
  -moz-box-align: end;
  -o-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end
}

.acea-row.row-center {
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -o-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center
}

.acea-row.row-right {
  -webkit-box-pack: end;
  -moz-box-pack: end;
  -o-box-pack: end;
  -ms-flex-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end
}

.acea-row.row-left {
  -webkit-box-pack: start;
  -moz-box-pack: start;
  -o-box-pack: start;
  -ms-flex-pack: start;
  -webkit-justify-content: flex-start;
  justify-content: flex-start
}

.acea-row.row-between {
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -o-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between
}

.acea-row.row-around {
  justify-content: space-around;
  -webkit-justify-content: space-around
}

.acea-row.row-column-around {
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: space-around;
  -webkit-justify-content: space-around
}

.acea-row.row-column {
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -o-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column
}

.acea-row.row-column-between {
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -o-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -o-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between
}

.acea-row.row-center-wrapper {
  -webkit-box-align: center;
  -moz-box-align: center;
  -o-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -moz-box-pack: center;
  -o-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center
}

.acea-row.row-between-wrapper {
  -webkit-box-align: center;
  -moz-box-align: center;
  -o-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -o-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between
}

</style>
